module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f416.d0834125.svg";